document.addEventListener("DOMContentLoaded", function () {

  // 1) Remover ?variant=... da URL para evitar seleção automática do tema
  if (location.search.includes("variant=")) {
    const newUrl = location.pathname + location.hash;
    history.replaceState({}, "", newUrl);
  }

  function setAddToCartState(form, enabled, label) {
    const btn = form.querySelector("[name='add']");
    if (!btn) return;
    btn.disabled = !enabled;
    if (label) btn.textContent = label;
  }

  function resetVariantPicker(picker) {
    if (!picker) return;

    // a) Rádios (botões / swatches)
    picker.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.removeAttribute("checked");
      input.checked = false;
    });

    // b) Dropdowns (um <select> por opção)
    picker.querySelectorAll(".variant-option__select").forEach((sel) => {
      let first = sel.options[0];
      if (!first || first.value !== "") {
        const placeholder = new Option("Selecione uma opção", "", true, true);
        placeholder.disabled = true;
        sel.insertBefore(placeholder, sel.firstChild);
      } else {
        sel.selectedIndex = 0;
      }
      sel.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // c) Zerar o input oculto de variante
    const form = picker.closest("form[action*='/cart/add']") || picker.closest("form");
    if (form) {
      const hiddenId = form.querySelector('input[name="id"], select[name="id"]');
      if (hiddenId) {
        hiddenId.value = "";
        hiddenId.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  function updateAddToCartState(form) {
    if (!form) return;

    const selects = Array.from(form.querySelectorAll(".variant-option__select"));
    const radioGroups = Array.from(form.querySelectorAll(".variant-option--buttons"));

    const anyEmptySelect = selects.some(s => !s.value);
    const anyUnchosenRadio = radioGroups.some(group =>
      !group.querySelector('input[type="radio"]:checked')
    );

    if (anyEmptySelect || anyUnchosenRadio) {
      setAddToCartState(form, false, "Selecione uma opção");
    } else {
      setAddToCartState(form, true, "Adicionar ao carrinho");
    }
  }

  function initForm(form) {
    const picker = form.closest("product-form")?.querySelector("variant-picker") ||
                   form.querySelector("variant-picker") ||
                   document.querySelector("variant-picker");

    // Reset inicial
    setTimeout(() => {
      resetVariantPicker(picker);
      setAddToCartState(form, false, "Selecione uma opção");
    }, 150);
  }

  // Inicializa todos os forms já presentes
  document.querySelectorAll("form[action*='/cart/add']").forEach(initForm);

  // Delegação de evento para qualquer mudança futura (inclusive quick-modal)
  document.addEventListener("change", function (evt) {
    const form = evt.target.closest("form[action*='/cart/add']");
    if (!form) return;
    updateAddToCartState(form);
  });

  // Inicializa forms que são carregados dinamicamente
  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("form[action*='/cart/add']").forEach(initForm);
  });

  // Inicializa quick-modals que podem ser abertas a qualquer momento
  function initQuickModals() {
    document.querySelectorAll(".quick-modal").forEach(modal => {
      modal.querySelectorAll("form[action*='/cart/add']").forEach(initForm);
    });
  }

  // Observa adição de novos modais dinamicamente
  const observer = new MutationObserver(() => initQuickModals());
  observer.observe(document.body, { childList: true, subtree: true });

});
